export default __webpack_public_path__ + "static/media/news.2e2d63cf.svg";